module.exports = __webpack_public_path__ + "static/media/vodoschetchiki.6168d73e.png";